/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportPurchase$Pdf$Params {
  id: string;

/**
 * Export format: EXCEL or PDF
 */
  format: 'EXCEL' | 'PDF';

/**
 * Language code for export labels (hu or en). Defaults to hu.
 */
  lang?: string;
}

export function exportPurchase$Pdf(http: HttpClient, rootUrl: string, params: ExportPurchase$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportPurchase$Pdf.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('format', params.format, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportPurchase$Pdf.PATH = '/purchase/{id}/export';
